import Header from '../Header';
import Sidebar from '../Sidebar';

import ProjectSidebar from './ProjectSidebar/ProjectSidebar';

interface Props {
  children: React.ReactNode;
}

const DashboardLayout = ({ children }: Props) => {
  return (
    <div className="h-screen bg-background ">
      <Header />

      <div className="flex h-[calc(100vh-90px)] pt-[90px]">
        <Sidebar />

        <main className="flex-1  ml-64 p-4">{children}</main>

        <ProjectSidebar />
      </div>
    </div>
  );
};

export default DashboardLayout;
